import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

// Páginas principales
import Home from '../pages/Home';
import Contact from '../pages/Contact';

// Nosotros - páginas independientes
import QuienesSomos from '../pages/nosotros/QuienesSomos';
import MisionVision from '../pages/nosotros/MisionVision';
import Equipo from '../pages/nosotros/Equipo';
import Valores from '../pages/nosotros/Valores';

// Servicios Minería
import Ventilacion from '../pages/servicios/Ventilacion';
import Sostenimiento from '../pages/servicios/Sostenimiento';
import MetanoPolvo from '../pages/servicios/MetanoPolvo';
import PTO from '../pages/servicios/PTO';
import AsesoriasMine from '../pages/servicios/AsesoriasMine';
import MiningServices from '../pages/MiningServices';

// Servicios Ambiental
import ICAS from '../pages/servicios/ICAS';
import EstudiosAguas from '../pages/servicios/EstudiosAguas';
import Licencias from '../pages/servicios/Licencias';
import PMA from '../pages/servicios/PMA';
import HuellaCarbone from '../pages/servicios/HuellaCarbone';
import EnvironmentalServices from '../pages/EnvironmentalServices';
import SoftwarePage from '../pages/SoftwarePage';
import SoftwareMinero from '../pages/software/SoftwareMinero';
import SoftwareAmbiental from '../pages/software/SoftwareAmbiental';

import NotFound from '../pages/NotFound';
import '../styles/globals.css';

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app-wrapper">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />

            {/* Nosotros */}
            <Route path="/nosotros" element={<QuienesSomos />} />
            <Route path="/nosotros/quienes-somos" element={<QuienesSomos />} />
            <Route path="/nosotros/mision-vision" element={<MisionVision />} />
            <Route path="/nosotros/equipo" element={<Equipo />} />
            <Route path="/nosotros/valores" element={<Valores />} />

            {/* Servicios Minería */}
            <Route path="/servicios/mineria" element={<MiningServices />} />
            <Route path="/servicios/ventilacion" element={<Ventilacion />} />
            <Route path="/servicios/sostenimiento" element={<Sostenimiento />} />
            <Route path="/servicios/metano-polvo" element={<MetanoPolvo />} />
            <Route path="/servicios/pto" element={<PTO />} />
            <Route path="/servicios/asesorias-mineras" element={<AsesoriasMine />} />

            {/* Servicios Ambiental */}
            <Route path="/servicios/ambiental" element={<EnvironmentalServices />} />
            <Route path="/servicios/icas" element={<ICAS />} />
            <Route path="/servicios/estudios-aguas" element={<EstudiosAguas />} />
            <Route path="/servicios/licencias" element={<Licencias />} />
            <Route path="/servicios/pma" element={<PMA />} />
            <Route path="/servicios/huella-carbono" element={<HuellaCarbone />} />

            {/* Software */}
            <Route path="/software"           element={<SoftwarePage />} />
            <Route path="/software/minero"    element={<SoftwareMinero />} />
            <Route path="/software/ambiental" element={<SoftwareAmbiental />} />

            {/* Otros */}
            <Route path="/contacto" element={<Contact />} />

            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}
